export default __webpack_public_path__ + "static/media/wago-750-8212.a5a85382.jpg";